import React from "react";
import { array, func, object, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { MenuItem } from "../helper-components";

import "./navbar.m.css";

// please don't remove the comments

const Navbar = ({ menu, domainInfo, isVerticalMenubar, domainSlug, toggleVerticalMenubar, publisherAttributes }) => {
  // const [childMenuVerticalBar, setChildMenuVerticalBar] = useState({ showChildMenu: false, activeMenuItem: null });  // need this for supproting sub menu items
  const menuItemClick = e => {
    toggleVerticalMenubar(); // Close the vertical menu bar
  };

  // const renderChildMenuItems = childrenItems => (
  //   <ul>
  //     {childrenItems.map((item, index) => (
  //       <li
  //         key={index}
  //         styleName={`menu-item ${item["item-type"] === "placeholder" ? "menu-item-placeholder" : ""}`}
  //         className="menu-item"
  //       >
  //         <MenuItem item={item} itemClick={e => menuItemClick(e, item)} />
  //       </li>
  //     ))}
  //   </ul>
  // );  // need this for supproting sub menu items

  // const toggleChildMenu = item => { // need this for supproting sub menu items
  //   item === childMenuVerticalBar.activeMenuItem
  //     ? setChildMenuVerticalBar({ showChildMenu: false, activeMenuItem: null })
  //     : setChildMenuVerticalBar({ showChildMenu: true, activeMenuItem: item });
  // };
  return (
    <nav
      styleName={`navbar ${domainInfo && domainInfo.navClassName ? domainInfo.navClassName : ""}`}
      className="navbar"
    >
      {menu && menu.length > 0 ? (
        <ul styleName="navbar-list" className="navbar-list">
          {menu.map((item, index) => (
            <li
              key={index}
              styleName={`menu-item ${publisherAttributes.lang}-menu-item ${
                item["item-type"] === "placeholder" ? "menu-item-placeholder" : ""
              }`}
              className={`menu-item ${publisherAttributes.lang}-menu-item ${
                domainSlug === "kishoralo" && isVerticalMenubar ? "kishoralo-menu-item" : ""
              }`}
            >
              <div>
                <MenuItem item={item} itemClick={e => menuItemClick(e, item)} />
              </div>

              {/* {isVerticalMenubar && item.children.length > 0 && item.id && ( // need this for supproting sub menu items
              <span onClick={() => toggleChildMenu(item.id)}>toggle</span>
            )} */}
              {/* {item.children.length > 0 &&
              childMenuVerticalBar.showChildMenu &&
              item.id &&
              item.id === childMenuVerticalBar.activeMenuItem &&
              renderChildMenuItems(item.children)} */}
            </li>
          ))}
        </ul>
      ) : null}
    </nav>
  );
};

Navbar.propTypes = {
  menu: array,
  navigateToPage: func,
  isVerticalMenubar: bool,
  domainInfo: object,
  domainSlug: string,
  toggleVerticalMenubar: func,
  publisherAttributes: object
};

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url)
});

const mapStateToProps = state => {
  return {
    domainSlug: get(state, ["qt", "domainSlug"]),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
